module.exports = __webpack_public_path__ + "e0106718/img/lock-icon.bb9c7166.svg";